import { registerGlobalErrorHandlers } from "./globalErrorHandlers";

// Capture uncaught errors and unhandled promise rejections that escape React's error boundary
registerGlobalErrorHandlers();

import("./TncCreationApp");
